var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([9222,2385,9922,3172,5845,2005].map(__webpack_require__.e, __webpack_require__)).then(next);
};